import { Outlet, Link, useNavigate, useLocation } from 'react-router-dom';
import { useAdminAuth } from '../../context/AdminAuth';

export default function AdminLayout() {
    const { logout } = useAdminAuth();
    const navigate = useNavigate();
    const location = useLocation();

    const handleLogout = () => {
        logout();
        navigate('/admin/login');
    };

    const menuItems = [
        { path: '/admin', label: 'Dashboard', icon: '📊' },
        { path: '/admin/posts', label: 'Նորություններ', icon: '📝' },
    ];

    return (
        <div className="min-h-screen rounded-none flex bg-gray-50">
            <aside className="w-64 rounded-none bg-[#0B3B6F] text-white flex flex-col">
                <div className="p-6 border-b border-white/10">
                    <h2 className="text-lg font-black uppercase tracking-wider">NWTA Admin</h2>
                </div>
                
                <nav className="flex-1 p-4 space-y-1">
                    {menuItems.map((item) => (
                        <Link
                            key={item.path}
                            to={item.path}
                            className={`flex items-center gap-3 px-4 py-3 text-sm font-bold uppercase tracking-wider transition-colors ${
                                location.pathname === item.path
                                    ? 'bg-[#0FA4E8] text-white'
                                    : 'text-white/70 hover:bg-white/10 hover:text-white'
                            }`}
                        >
                            <span>{item.icon}</span>
                            {item.label}
                        </Link>
                    ))}
                </nav>
                
                <div className="p-4 border-t border-white/10">
                    <Link to="/" className="block text-sm text-white/50 hover:text-white mb-2">
                        ← Վերադառնալ կայք
                    </Link>
                    <button onClick={handleLogout} className="w-full text-left text-sm text-red-400 hover:text-red-300">
                        Ելք
                    </button>
                </div>
            </aside>
            
            <main className="flex-1 p-8">
                <Outlet />
            </main>
        </div>
    );
}